import { createStyle } from '@gluestack-style/react';

export const ModalFooter = createStyle({
  flexDirection: 'row',
  justifyContent: 'flex-end',
  alignItems: 'center',
  flexWrap: 'wrap',
});
